import React from "react";
import { Block } from "@randajan/jet-react/dom/block";

import "./AboutUs.scss";
import { OpCard } from "./OpCard/OpCard";
import { Article } from "../../elements/Article/Article";
import { Locale } from "../../assets/Locale";
import { useBeam } from "@randajan/bifrost/client/react";
import { opsBeam } from "../../assets/beams/opsBeam";
import { Link } from "@randajan/jet-react/dom/link";

export const AboutUs = (props)=>{
    const {} = props;
    const say = Locale.use();
    const { data:ops } = useBeam(opsBeam);

    return (
        <Block className="AboutUs" caption={say("navAbout")} level={0}>
            <Article className="slab paragraph" storeId={`aboutCreated`}/>
            <Block className="team slab wall" caption={say("aboutTeamCaption")}>
                {ops?.map(([key, op])=>op.isPublic && <OpCard key={key} {...op}/>)}
            </Block>
            <div className="slab">
                <Link to="/partnerships">{say("aboutPartnrshipLink")}</Link>
            </div>
        </Block>
    );
};
